<template lang="pug">
shListData(title="Facturas" resolver="invoices" keyData="invoice" component="shInvoice")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Invoices',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/invoice/Invoices.vue